<template>
    <v-menu left :top="topPosition"  v-bind:class="{ 'cf-fixed-select-calendar': !topPosition }"
        ref="fromDateMenu"
        v-model="fromDateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
         max-width="290px"
        min-width="290px"
    >
        <template v-if="!manualEdit" v-slot:activator="{ on }">
            <v-text-field
                :label="(label) ? label : inputLabel"
                hint="DD/MM/YYYY"
                placeholder="Selecciona fecha"
                persistent-hint
                append-icon="mdi-calendar"
                outlined
                readonly
                :value="dateFormatted"
                clearable
                :rules="(required) ? [...ruleRequired] : []"
                :dense="dense"
                @click:clear="clearDate"
                v-on="on"
            ></v-text-field>
        </template>
        <template v-else v-slot:activator="{ on }">
            <v-text-field
                :label="(label) ? label : inputLabel"
                hint="DD/MM/YYYY"
                placeholder="Selecciona fecha"
                persistent-hint
                append-icon="mdi-calendar"
                :value="dateFormatted"
                @input="validateInputDate"
                v-mask="'##/##/####'"
                :rules="checkFormatDate"
                clearable
                @click:clear="clearDate"
                v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker 
            v-model="date" 
            @change="changeData()"
            no-title 
            locale="ES"
            :min="(min) ? min : null"
            :max="(max) ? max : null"
            @input="fromDateMenu = false"
            :show-current="(showInitial) ? showInitial : null"
        ></v-date-picker>
    </v-menu>
</template>

<script>
    import moment from 'moment'
    export default {
        data() {
            return {
                date: null,
                fromDateMenu: false,
                checkFormatDate: [
                    v =>{
                        var date = moment(v,'L',true);
                        return date.isValid() || 'Formato de fecha incorrecto'
                    }
                ],
                ruleRequired: [
                    v => !!v || 'Campo obligatorio'
                ],
                inputLabel: 'Fecha'
            }
        },
        created() {
            this.setInitialData();
        },
        computed: {
            dateFormatted(){
                return (this.date) ? this.formatDate(this.date) : '';
            }
        },

        methods: {
            setInitialData(){
             
                if(!this.model){
                    this.date = '';
                    return '';
                }
                
                if(this.sourceFormat && this.sourceFormat === 'DD/MM/AAAA'){
                    const [day, month, year] = this.model.split('/');
                    this.date = `${year}-${month}-${day}`
                }else{
                    this.date = this.model + '';
                }                

                // if(!this.label){
                //     this.label = 'Fecha';
                // }
            },
            formatDate (date) {
                if (!date) return null
                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            changeData(){
                let format = this.date;
                if(this.saveFormat){
                    switch(this.saveFormat){
                        case 'DD/MM/AAAA':
                            format = this.dateFormatted;
                            break;
                    }
                }
                this.$emit('setDate', format)
            },
            clearDate(){
                this.date='';
                this.$emit('setDate', this.date)
            },
            validateInputDate(i){
                var inputDate = moment(i,'L',true);
                if(inputDate.isValid()){
                    const [day, month, year] = i.split('/');
                    this.date = `${year}-${month}-${day}`
                }
                this.changeData()
            }
        },
        watch: { 
            model: function() { // watch it
                this.setInitialData();
            }
        },
        props:['model', 'sourceFormat', 'saveFormat', 'manualEdit', 'label','topPosition', 'required', 'max', 'min', 'showInitial','dense']
    }
</script>